import { render, staticRenderFns } from "./TaxInvoiceOnRoll.vue?vue&type=template&id=6db7f9d0&scoped=true&"
import script from "./TaxInvoiceOnRoll.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceOnRoll.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=6db7f9d0&scoped=true&lang=css&"
import style1 from "./TaxInvoiceOnRoll.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./TaxInvoiceOnRoll.vue?vue&type=style&index=2&id=6db7f9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db7f9d0",
  null
  
)

export default component.exports